import React, { useState } from 'react';
import { isDemoMode } from '../demo/useDemoMode';

/**
 * Demo Banner - Shows a notification that the app is in demo mode
 * Only visible when accessing via demo.minitask.no
 */
const DemoBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  
  // Only show in demo mode
  if (!isDemoMode() || !isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white py-2 px-4 text-center relative z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
        <span className="material-symbols-outlined text-lg animate-pulse">info</span>
        <p className="text-sm font-medium">
          <strong>Demo-modus:</strong> Dette er en demonstrasjon av Minitask. Ingen data lagres.
        </p>
        <a 
          href="https://minitask.no" 
          className="ml-2 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-full text-xs font-medium transition-colors"
        >
          Gå til minitask.no
        </a>
        <button
          onClick={() => setIsVisible(false)}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full transition-colors"
          aria-label="Lukk"
        >
          <span className="material-symbols-outlined text-sm">close</span>
        </button>
      </div>
    </div>
  );
};

export default DemoBanner;
